<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="contract__icon"
  >
    <path
      d="M5 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H8.697M15 12V16H19M15 9V5C15 4.46957 14.7893 3.96086 14.4142 3.58579C14.0391 3.21071 13.5304 3 13 3H11"
      :stroke="colorHover"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 9H9M5 13H8M5 3C5 2.46957 5.21071 1.96086 5.58579 1.58579C5.96086 1.21071 6.46957 1 7 1H9C9.53043 1 10.0391 1.21071 10.4142 1.58579C10.7893 1.96086 11 2.46957 11 3C11 3.53043 10.7893 4.03914 10.4142 4.41421C10.0391 4.78929 9.53043 5 9 5H7C6.46957 5 5.96086 4.78929 5.58579 4.41421C5.21071 4.03914 5 3.53043 5 3ZM11 16C11 17.0609 11.4214 18.0783 12.1716 18.8284C12.9217 19.5786 13.9391 20 15 20C16.0609 20 17.0783 19.5786 17.8284 18.8284C18.5786 18.0783 19 17.0609 19 16C19 14.9391 18.5786 13.9217 17.8284 13.1716C17.0783 12.4214 16.0609 12 15 12C13.9391 12 12.9217 12.4214 12.1716 13.1716C11.4214 13.9217 11 14.9391 11 16Z"
      :stroke="colorHover"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "ContractIcon",
  props: {
    colorHover: {
      required: false,
      type: String,
      default: "var(--textinactive)"
    }
  }
};
</script>
